(function () {
  var PIN_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" focusable="false">' +
    '<path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>' +
    '</svg>';

  function numOrNull(value) {
    if (value == null || value === '') return null;
    var n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function buildMapQuery(address, lat, lng) {
    if (address) return encodeURIComponent(address);
    if (lat != null && lng != null) return lat + ',' + lng;
    return '';
  }

  function buildDirectionsUrl(title, address, lat, lng) {
    if (address) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address);
    }
    if (lat != null && lng != null) {
      return (
        'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng)
      );
    }
    if (title) {
      return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(title);
    }
    return '';
  }

  function buildEmbedSrc(title, address, lat, lng, zoom) {
    var query = buildMapQuery(address, lat, lng);
    if (!query && title) query = encodeURIComponent(title);
    if (!query) return '';
    return 'https://www.google.com/maps?q=' + query + '&z=' + zoom + '&output=embed';
  }

  /** City label + region code (e.g. "Aurora, CO") when address/payload has a state. */
  function titleWithRegion(title, address, regionCode) {
    var t = String(title || '').trim();
    if (!t) return t;
    var code = String(regionCode || '')
      .trim()
      .toUpperCase();
    if (!code || code.length !== 2) {
      var m = String(address || '').match(/,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
      code = m ? m[1].toUpperCase() : '';
    }
    if (!code || code.length !== 2) return t;
    if (new RegExp(',\\s*' + code + '\\s*$', 'i').test(t)) return t;
    return t + ', ' + code;
  }

  function ensureLocationOverlay(frame, showLabel) {
    if (!frame || !showLabel) return null;
    var loc = frame.querySelector('[data-pic-map-location]');
    if (loc) return loc;

    loc = document.createElement('a');
    loc.className = 'pic-map__location';
    loc.setAttribute('data-pic-map-location', '');
    loc.target = '_blank';
    loc.rel = 'noopener noreferrer';
    loc.innerHTML =
      '<span class="pic-map__location-pin" aria-hidden="true">' +
      PIN_SVG +
      '</span>' +
      '<span class="pic-map__location-text">' +
      '<span class="pic-map__location-title" data-pic-map-location-title></span>' +
      '<span class="pic-map__location-address" data-pic-map-location-address hidden></span>' +
      '</span>';
    frame.appendChild(loc);
    return loc;
  }

  function updateLocationOverlay(loc, title, address, directionsUrl) {
    if (!loc) return;
    var titleEl = loc.querySelector('[data-pic-map-location-title]');
    var addressEl = loc.querySelector('[data-pic-map-location-address]');
    if (titleEl) titleEl.textContent = title || '';
    if (addressEl) {
      if (address) {
        addressEl.textContent = address;
        addressEl.hidden = false;
      } else {
        addressEl.textContent = '';
        addressEl.hidden = true;
      }
    }
    if (directionsUrl && loc.tagName === 'A') {
      loc.href = directionsUrl;
    }
    loc.hidden = !title && !address;
  }

  function readDefaultDetail(mapEl) {
    return {
      title: mapEl.getAttribute('data-pic-default-title') || '',
      address: mapEl.getAttribute('data-pic-default-address') || '',
      lat: numOrNull(mapEl.getAttribute('data-pic-default-lat')),
      lng: numOrNull(mapEl.getAttribute('data-pic-default-lng')),
    };
  }

  function composeAddress(payload) {
    var address = String((payload && payload.address) || '').trim();
    if (address) return address;
    var city = String((payload && payload.city) || '').trim();
    var state = String((payload && (payload.state || payload.region_code || payload.state_code)) || '').trim();
    var zip = String((payload && (payload.zip || payload.postal_code)) || '').trim();
    var parts = [];
    if (city) parts.push(city);
    if (state) parts.push(state);
    var line = parts.join(', ');
    if (zip) line = line ? line + ' ' + zip : zip;
    return line;
  }

  function applyMapDetail(mapEl, detail, useDefault) {
    if (!mapEl) return;
    var mode = mapEl.getAttribute('data-pic-map-dynamic');
    if (!mode) return;

    var payload = useDefault ? readDefaultDetail(mapEl) : detail || {};
    var address = composeAddress(payload);
    var title = titleWithRegion(
      String(payload.title || '').trim(),
      address,
      payload.region_code || payload.state_code || payload.state || ''
    );
    var lat = numOrNull(payload.lat);
    var lng = numOrNull(payload.lng);
    var zoom = mapEl.getAttribute('data-pic-map-zoom') || '15';
    var showLabel = mapEl.getAttribute('data-pic-show-label') === '1';
    var frame = mapEl.querySelector('[data-pic-map-frame]') || mapEl;
    var iframe = mapEl.querySelector('[data-pic-map-iframe]');
    var awaiting = mapEl.querySelector('[data-pic-map-awaiting]');
    var hasPlace = !!(title || address || (lat != null && lng != null));

    if (iframe && mode !== 'label-only') {
      var src = hasPlace ? buildEmbedSrc(title, address, lat, lng, zoom) : '';
      if (src) {
        iframe.src = src;
        iframe.hidden = false;
      } else {
        iframe.removeAttribute('src');
        iframe.hidden = true;
      }
    }

    mapEl.classList.toggle('pic-map--awaiting', !hasPlace);
    if (awaiting) awaiting.hidden = hasPlace;

    if (showLabel) {
      var loc = ensureLocationOverlay(frame, true);
      var directionsUrl = hasPlace ? buildDirectionsUrl(title, address, lat, lng) : '';
      updateLocationOverlay(loc, title, address, directionsUrl);
      if (loc) loc.hidden = !hasPlace;
    }
  }

  function collectEnabledFacilities(detail) {
    var out = [];
    if (!detail) return out;
    var seen = Object.create(null);
    function push(label) {
      var t = String(label || '').trim();
      if (!t) return;
      var key = t.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push(t);
    }
    if (Array.isArray(detail.facilities)) {
      detail.facilities.forEach(push);
    }
    if (detail.wheelchair_accessible) push('Wheelchair accessible');
    if (detail.accessible_toilets) push('Accessible toilets');
    if (detail.ground_level) push('Ground level');
    if (detail.accessible_parking) push('Accessible parking spot available');
    if (detail.lift_to_all_floors) push('Lift to all floors');
    return out;
  }

  function renderFacilities(root, labels) {
    if (!root) return;
    var grid = root.querySelector('[data-pic-facilities-grid]');
    var empty = root.querySelector('[data-pic-facilities-empty]');
    if (!grid) return;
    var list = Array.isArray(labels) ? labels.filter(Boolean) : [];
    grid.innerHTML = list
      .map(function (label) {
        return (
          '<div class="pic-facility" data-pic-facility data-pic-facility-label="' +
          String(label).replace(/"/g, '&quot;') +
          '">' +
          '<span class="pic-facility__icon pic-facility__icon--yes" aria-hidden="true">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg></span><span>' +
          String(label)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;') +
          '</span></div>'
        );
      })
      .join('');
    if (empty) empty.hidden = list.length > 0;
  }

  function onVenueSelected(e) {
    var detail = e && e.detail;
    if (!detail) return;
    document.querySelectorAll('[data-pic-map-dynamic]').forEach(function (mapEl) {
      applyMapDetail(mapEl, detail, false);
    });
    var facilities = collectEnabledFacilities(detail);
    document.querySelectorAll('[data-pic-section]').forEach(function (root) {
      if (facilities.length) renderFacilities(root, facilities);
    });
  }

  function defaultFacilities(root) {
    var raw = root && root.getAttribute('data-pic-default-facilities');
    if (!raw) return [];
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function onVenueReset() {
    document.querySelectorAll('[data-pic-map-dynamic]').forEach(function (mapEl) {
      applyMapDetail(mapEl, null, true);
    });
    document.querySelectorAll('[data-pic-section]').forEach(function (root) {
      renderFacilities(root, defaultFacilities(root));
    });
  }

  document.addEventListener('wbw:venue-selected', onVenueSelected);
  document.addEventListener('wbw:venue-reset', onVenueReset);

  function scrollToBookingWizard() {
    var wizard = document.querySelector('.wbw-root');
    if (!wizard || !wizard.scrollIntoView) return;
    wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initSection(root) {
    if (!root || root.dataset.picInit === '1') return;
    root.dataset.picInit = '1';

    root.querySelectorAll('[data-pic-scroll-wizard]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToBookingWizard();
      });
    });

    var tabs = root.querySelectorAll('[data-pic-tab]');
    var panels = root.querySelectorAll('[data-pic-panel]');
    var select = root.querySelector('[data-pic-tabs-select]');
    if (!tabs.length || !panels.length) return;

    function activate(id) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-pic-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-pic-panel') === id;
        panel.classList.toggle('is-active', on);
        panel.hidden = !on;
      });
      if (select && select.value !== id) select.value = id;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-pic-tab'));
      });
    });

    if (select) {
      select.addEventListener('change', function () {
        activate(select.value);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pic-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
})();
